import React, {  Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

/* Actions */
import { printProofOfDelivery } from '../../../redux/actions';

class ProofOfDelivery extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orderDetails: null,
			backupOrderDetails: null
		}
		this.updateStateWithOrderDetails = this.updateStateWithOrderDetails.bind(this);
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		var self = this,
			accountNumber = self.props.getSelectedAccountNumber();

		if(self.props.state.order.orderDetails && accountNumber) {
			self.updateStateWithOrderDetails(self.props.state.order.orderDetails);
		} else {
			browserHistory.push('/manageorders');
		}
	}

	updateStateWithOrderDetails(response) {
		var self = this;
		if(!response.status) {
			self.setState({
				errorMessage: response.responseMessage
			})
		} else {
			//Save backup for handle print service
			self.setState({
				backupOrderDetails: JSON.parse(JSON.stringify(response.responseObject))
			});

			self.setState({
				orderDetails: response.responseObject
			});
		}
	}

	handlePrint(event) {
		event.preventDefault();
		var self = this;
		self.setState({
			errorMessage: ''
		})
		let payload = JSON.parse(JSON.stringify(self.state.backupOrderDetails));
		self.props.printProofOfDelivery(payload, 'requestType=printPOD', (response) => {
			if(!response.status) {
				self.setState({
					errorMessage: response.responseMessage
				})
			} else {
				window.open(response.responseObject);
			}
		})
	}

    render() {
		let orderDetails = this.state.orderDetails,
			{ signatureDetails } = this.props.state.order;
        return (
			<div>
				<p className="textRight">
					<a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={this.handlePrint.bind(this)} href="">Print Proof of Delivery</a>
				</p>
				<div className="push">
					<h1 className="pageTitle">Proof of Delivery</h1>
				</div>
				<p className="bold red">{this.state.errorMessage}</p>
				<div className="push columns">
					<div className="column column1">
						<p>
							<strong>Account #:</strong> {orderDetails && orderDetails.accountNumber}<br />
							<strong>CSO (Order number):</strong> {orderDetails && orderDetails.orderNumber}
						</p>
					</div>
					<div className="column column2">
						{orderDetails && <p>
							<strong>Bill to</strong>:<br />
							{orderDetails.billingAddress.addressName && <span>{orderDetails.billingAddress.addressName}<br /></span>}
							<span>{orderDetails.billingAddress.address1}<br /></span>
							{orderDetails.billingAddress.address2 && <span>{orderDetails.billingAddress.address2}<br /></span>}
							<span>{orderDetails.billingAddress.city + ', ' + orderDetails.billingAddress.state + ' ' + orderDetails.billingAddress.zip}<br /></span>
							{orderDetails.billingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.billingAddress.phone)}<br /></span>}
						</p>}
					</div>
					<div className="column column3">
						&nbsp;
					</div>
				</div>
				{orderDetails && <div>
					<hr />
					<div className="columns">
						<div className="column column1">
							<h3>Invoice # {orderDetails.invoiceNumber}</h3>
							<p>
								<strong>P.O.#</strong>: {orderDetails.poNumber}<br />
								<strong>Order Date</strong>: {orderDetails.orderDate && this.props.formatDate(orderDetails.orderDate, 'MM/DD/YY')}<br />
								<strong>Signed</strong>: {signatureDetails && signatureDetails.responseObject && signatureDetails.responseObject.sig_date?this.props.formatDate(moment(signatureDetails.responseObject.sig_date).format('YYYY/MM/DD'), 'MM/DD/YY'):null}<br /><br />
							</p>
							<p><span style={{float: 'left'}}>Signature:</span> {signatureDetails && signatureDetails.responseObject && signatureDetails.responseObject.signatureURL?<img src={signatureDetails.responseObject.signatureURL} width="70" alt="Physical Signature" />:null}</p>
						</div>
						{orderDetails.shippingAddress && <div className="column column2">
							<p>&nbsp;</p>
							<p>
								<strong>Ship to</strong>:<br />
								{orderDetails.shippingAddress.addressName && <span>{orderDetails.shippingAddress.addressName}<br /></span>}
								<span>{orderDetails.shippingAddress.address1}<br /></span>
								{orderDetails.shippingAddress.address2 && <span>{orderDetails.shippingAddress.address2}<br /></span>}
								<span>{orderDetails.shippingAddress.city + ', ' + orderDetails.shippingAddress.state + ' ' + orderDetails.shippingAddress.zip}<br /></span>
								{orderDetails.shippingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.shippingAddress.phone)}<br /></span>}
							</p>
						</div>}
						<div className="column column3">&nbsp;</div>
					</div>
				</div>}
				<table className="dataTable proofOfDeliveryTable">
					<thead>
						<tr>
							<th className="productNumber">Product</th>
							<th className="quantity" style={{textAlign: 'center'}}>Quantity</th>
						</tr>
						<tr>
							<th className="toast" colSpan={2}></th>
						</tr>
					</thead>
					<tbody>
						{orderDetails && orderDetails.items.map((item, index) => {
							return <tr key={index}>
								<td className="productNumber">{item.item}</td>
								<td className="quantity" style={{textAlign: 'center'}}>{item.quantity}</td>
							</tr>
						})}
					</tbody>
				</table>
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	printProofOfDelivery: (payload, queryStringParams, callback) => dispatch(printProofOfDelivery(payload, queryStringParams, callback))
});

ProofOfDelivery = connect(mapStateToProps, mapDispatchToProps)(ProofOfDelivery);
export default ProofOfDelivery;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/proofOfDelivery.js